import { Dispatch } from "react"
import { createContext } from "react"
import { InstallerAction, InstallerRegistration } from "./reducers/registrationReducer"
import { InstallersStatusConfig, InstallersStatusConfigAction } from "./reducers/installersStatusReducer"
import { TenantAction, TenantState } from "./reducers/tenantReducer"
import { ChecklistItemConfigAction, ChecklistItemConfig } from "./reducers/checklistItemReducer"

export interface ApplicationState {
  tenant: TenantState
  registration: InstallerRegistration
  installersStatusConfig: InstallersStatusConfig,
  checklistItemsConfig: ChecklistItemConfig
}

export interface Context {
  state: ApplicationState
  dispatch: Dispatch<InstallerAction | InstallersStatusConfigAction | TenantAction | ChecklistItemConfigAction>
}

const initialState = {
  tenant: {
    loading: false,
    error: undefined,
    config: undefined
  },
  registration: {
    token: null,
    installer: undefined,
    loading: false,
    deadline: undefined,
    authError: undefined
  },
  installersStatusConfig: {
    loading: false,
    error: undefined,
    list: undefined,
    dict: undefined
  },
  checklistItemsConfig: {
    loading: false,
    error: undefined,
    list: undefined
  }
}

const dispatch = () => { return }

export const AppContext = createContext<Context>({
  state: initialState,
  dispatch: dispatch
})